export default "__VITE_ASSET__BHYNR0tq__"